import { render, staticRenderFns } from "./PaginaBolle.vue?vue&type=template&id=fad78a0c"
import script from "./PaginaBolle.vue?vue&type=script&lang=js"
export * from "./PaginaBolle.vue?vue&type=script&lang=js"
import style0 from "./PaginaBolle.vue?vue&type=style&index=0&id=fad78a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports